import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "@shared/components/ui/table";
import { STATUS_OPTIONS, STATUS_COLORS } from "@shared/utils/constants";
import { formatPackageStatus, financial } from "@shared/utils/helper";
import { useTranslation } from "react-i18next";

export default function PackagesStatusTable({ packageStatus, data }) {
  const { t } = useTranslation();
  // Support both 'packageStatus' and 'data' props for backward compatibility
  const statusData = packageStatus || data || [];
  const TransferData = formatPackageStatus(statusData);
  const totals = TransferData.reduce(
    (acc, item) => {
      acc.count += item.count || item.value;
      acc.totalAmount += item.totalAmount;
      acc.totalCost += item.totalCost;
      acc.totalProfit += item.totalProfit;
      return acc;
    },
    { count: 0, totalAmount: 0, totalCost: 0, totalProfit: 0 }
  );

  return (
    <Table>
      <TableHeader className="bg-muted">
        <TableRow>
          <TableHead>{t("status.status")}</TableHead>
          <TableHead>{t("packages.packages")}</TableHead>
          <TableHead> {t("packages.totalAmount")}</TableHead>
          <TableHead>{t("dashboard.totalCost")}</TableHead>
          <TableHead>{t("dashboard.profit")}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {TransferData.map((item) => (
          <TableRow key={item.label}>
            <TableCell className="font-medium">
              <span
                className={`${
                  STATUS_COLORS[item.label]
                } p-1 text-xs rounded-md`}
              >
                {t(STATUS_OPTIONS[item.label])}
              </span>
            </TableCell>
            <TableCell>{item.count || item.value}</TableCell>
            <TableCell>
              {financial(item.totalAmount)} {t("main.currency")}
            </TableCell>
            <TableCell>
              {financial(item.totalCost)} {t("main.currency")}
            </TableCell>
            <TableCell>
              {financial(item.totalProfit)} {t("main.currency")}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
      <TableFooter>
        <TableRow>
          <TableCell className="font-medium">{t("main.total")}</TableCell>
          <TableCell>{totals.count}</TableCell>
          <TableCell>
            {financial(totals.totalAmount)} {t("main.currency")}
          </TableCell>
          <TableCell>
            {financial(totals.totalCost)} {t("main.currency")}
          </TableCell>
          <TableCell>
            {financial(totals.totalProfit)} {t("main.currency")}
          </TableCell>
        </TableRow>
      </TableFooter>
    </Table>
  );
}
